/* oxlint-disable typescript/no-non-null-assertion */
import { LinkButton } from '@cian/ui-kit';
import { TRoundButtonSize } from '@cian/ui-kit/button/types/TButtonSize';
import * as React from 'react';

import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';
import { trackBookButtonClick } from '../../utils/trackBookClick';

export interface IBookButtonDesktopProps {
  page: IPageState;
  total: number;
  position: number;
  phone?: string | null;
  favoriteEntity: IFavoriteEntity;
  size?: TRoundButtonSize;
}

export const BookButton: React.FC<IBookButtonDesktopProps> = ({
  favoriteEntity,
  page,
  total,
  position,
  size = 'XS',
}) => {
  const onClick = React.useCallback(() => {
    trackBookButtonClick({
      entity: favoriteEntity,
      position,
      total,
      deviceType: page.deviceType,
    });
  }, [favoriteEntity, position, total, page.deviceType]);

  return (
    <LinkButton
      href={favoriteEntity.externalOfferUrl}
      target="_blank"
      rel="noreferrer noopener"
      size={size}
      fullWidth={true}
      onClick={onClick}
    >
      Проверить даты
    </LinkButton>
  );
};
